<template>
  <span>
    <slot v-bind="{ formats }">
      {{ formats[0] }}
    </slot>
  </span>
</template>

<script>
import { format, Timezone } from "@/moment-tz.js";

export default {
  props: {
    timezone: String,
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    Timezone() {
      return this.timezone ? this.timezone : Timezone;
    },
    DateTime() {
      if (!this.value) return;
      return `${this.value?.date}T${this.value?.start}`;
    },
    DateFull() {
      if (!this.value) return;
      return format(this.value?.date, "MMM D, YYYY");
    },
    HourMin() {
      if (!this.value) return;
      return format(this.DateTime, "hh:mma", this.Timezone);
    },
    formats() {
      if (!this.value) return;
      return [this.HourMin, this.DateTime, this.DateFull];
    },
  },
};
</script>
